var createReactClass = require('create-react-class');
import React from 'react';

const EditModal = createReactClass({
  getInitialState: function() {
    return {
      reason: this.props.reason,
      label: this.props.reason.label,
      description: this.props.reason.description
    }
  },

  editReason: function(e) {
    $.ajax({
      type: 'put',
      url: this.props.editPath,
      data: {deferral_reason: {label: this.state.label, description: this.state.description}, type: this.props.type},
      dataType: 'json',
      success: function(res){
        window.location.reload()
      },
      error: function(res) {
        Cureus.Flash.alert('There was an issue, please try later.')
      }
    })
  },

  handleInputChange: function(e) {
    this.setState({[e.target.name]: e.target.value})
  },
  
  render: function() {
    return (
      <div className="reveal-modal middling" data-reveal id="edit-deferral-reason">
        <div className="modal-body">
          <div className='modal-close'>
            <a href='#' className='cancel-modal'>
              <img src="https://gallery.cureusjournals.com/collection/close_x.png"/>
            </a>
          </div>
          <div className="modal-content middling">
            <h4>Edit Deferral Reason</h4>
            <label htmlFor='label' id="label">Label</label>
            <input name="label" value={this.state.label} type="text" onChange={this.handleInputChange}  required='required'/>

            <label htmlFor='description'>Description</label>
            <textarea name="description" value={this.state.description} onChange={this.handleInputChange} id='description'/>
          </div>
          <div className='modal-footer'>
            <a className='cancel-modal button small secondary'>Cancel</a>
            <a className="button small primary success" onClick={this.editReason}>Edit Deferral Reason</a>
          </div>
        </div>
      </div>
    )
  }
});

export default EditModal;